import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-efd14770"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-swiper__item" }
const _hoisted_2 = { key: 0 }

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination, Thumbs } from 'swiper/modules';
import type SwiperClass from 'swiper';
import { computed, onMounted, Ref, ref } from 'vue';
// eslint-disable-next-line import/no-unresolved
import { SwiperModule } from 'swiper/types/shared';
import GallerySwiper from '@/components/UI/BaseSwiper/GallerySwiper.vue';

type SlidesGroupType = {
  id: number;
  title: string;
  slides: string[];
}[];
type GroupDataType = {
  modules: SwiperModule[];
  slides: string[];
  thumbsSwiper?: SwiperClass;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseImageGallery',
  props: {
    slidesGroup: {},
    widthItem: { default: 120 },
    itemsToShow: {},
    spaceBetween: { default: 5 },
    navigation: { type: Boolean, default: false },
    imgName: {},
    imgTitle: {}
  },
  setup(__props: any) {

const activeSwiper = ref<string>('');
const modules = [Pagination, Navigation, Thumbs];
const props = __props;

const groupData: Ref<{ [key: string]: GroupDataType }> = ref({});
const setThumbsSwiper = (index: string, swiper: SwiperClass) => {
  groupData.value[index].thumbsSwiper = swiper;
};
const changeActiveSwiper = (swiper: string) => {
  activeSwiper.value = swiper;
};
const gridTemplateColumns = computed(() => {
  const length = Object.keys(groupData.value)?.length;

  let columns: string[] = [];

  Object.keys(groupData.value).forEach(swiper => {
    if (groupData.value[swiper]?.slides?.length <= 1) {
      columns.push(`${props.widthItem}px`);
    } else {
      columns.push(`minmax(${100 / length}%, 100%)`);
    }
  });

  return columns.join(' ');
});

onMounted(() => {
  props.slidesGroup.forEach(group => {
    groupData.value[group.id] = {
      modules: [...modules],
      slides: [...group.slides],
    };
  });
  activeSwiper.value = String(props.slidesGroup[0].id);
});

return (_ctx: any,_cache: any) => {
  const _component_base_image = _resolveComponent("base-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(groupData.value), (swiper) => {
      return (_openBlock(), _createElementBlock("div", { key: swiper }, [
        _withDirectives(_createVNode(_unref(Swiper), {
          id: "top-swiper",
          modules: groupData.value[swiper].modules,
          navigation: _ctx.navigation,
          "space-between": 0,
          thumbs: { swiper: groupData.value[swiper].thumbsSwiper },
          zoom: true,
          class: "top-swiper"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupData.value[swiper].slides, (item, index) => {
              return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                key: index,
                class: "slide"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _renderSlot(_ctx.$slots, "item", {
                      data: { item: item, slides: groupData.value[swiper].slides }
                    })
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 2
        }, 1032, ["modules", "navigation", "thumbs"]), [
          [_vShow, activeSwiper.value === swiper]
        ])
      ]))
    }), 128)),
    _createElementVNode("div", {
      style: _normalizeStyle({
      display: 'grid',
      gridTemplateColumns: gridTemplateColumns.value,
      gap: '10px',
    })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(groupData.value), (swiper) => {
        return (_openBlock(), _createElementBlock("div", { key: swiper }, [
          (groupData.value[swiper]?.slides.length <= 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_base_image, {
                  "max-width": _ctx.widthItem + 'px',
                  name: _ctx.imgName,
                  src: groupData.value[swiper]?.slides[0],
                  title: _ctx.imgTitle,
                  "border-radius": "",
                  cover: "",
                  height: "70",
                  width: "100%",
                  onClick: ($event: any) => (changeActiveSwiper(swiper))
                }, null, 8, ["max-width", "name", "src", "title", "onClick"])
              ]))
            : (_openBlock(), _createBlock(GallerySwiper, {
                key: 1,
                "group-data": groupData.value,
                modules: groupData.value[swiper]?.modules,
                slides: groupData.value[swiper]?.slides,
                swiper: swiper,
                onClick: ($event: any) => (changeActiveSwiper(swiper)),
                onSwiper: ($event: any) => (setThumbsSwiper(swiper, $event))
              }, null, 8, ["group-data", "modules", "slides", "swiper", "onClick", "onSwiper"]))
        ]))
      }), 128))
    ], 4)
  ], 64))
}
}

})